import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { Illustration } from 'frontend-utils';
import type { Theme } from 'frontend-utils/utils/prism/theme';

import styles from './selection-card.module.css';

interface SettingsThemeSelectionCardSignature {
  Args: {
    checked: boolean;
    disabled?: boolean;
    imageAlt: string;
    imageHtml: string;
    label: string;
    onChange: (theme: Theme, highContrast: boolean | null) => void;
    value: Theme;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLLabelElement;
}

const SettingsThemeSelectionCard = <template>
  <label
    class="relative {{styles.container}} w-full py-400"
    for="theme-{{@value}}"
    ...attributes
  >
    <div class="mb-800 flex justify-center">
      <Illustration @html={{@imageHtml}} aria-label={{@imageAlt}} />
    </div>
    <div class="flex justify-between px-400">
      <input
        checked={{@checked}}
        class="sr-only"
        data-test-theme={{@value}}
        disabled={{@disabled}}
        id="theme-{{@value}}"
        name="theme-radio-group"
        type="radio"
        value={{@value}}
        {{on "change" (fn @onChange @value null)}}
      />
      <div class="text-300--regular">{{@label}}</div>
      <div class={{styles.circle}}></div>
    </div>
  </label>
</template> satisfies TOC<SettingsThemeSelectionCardSignature>;

export default SettingsThemeSelectionCard;
